<style scoped>
.statistic-block {
    position: relative;
}

.statistic-info {
    margin: 10px 0;
    height: 50px;
}

.statistic-info div p {
    display: inline;
}

.statistic-info div {
    text-align: center;
}

.statistic-info div .info-number {
    color: rgb(0, 183, 255);
}

.for-map-block {
    width: 100%;
    max-width: 100vw;
    bottom: 0;
    height: calc(100vh - 242px);
    display: block;
    position: relative;
}

.offine-faucets-checkbox-block {
    display: flex;
    height: 55px;
    border: 1px solid rgb(0, 95, 158);
    border-radius: 5px;
    padding: 5px;
    background-color: rgba(0, 95, 158, 0.219);
}

.offine-faucets-checkbox-block p,
.offine-faucets-checkbox-block .checkbox-block {
    display: inline-block;
}

.offine-faucets-checkbox-block p {
    padding: 3px 10px;
    color: rgb(233, 251, 255);
    font-size: 25px;
}

.offine-faucets-checkbox-block .checkbox-block {
    top: -7px;
    position: relative;
}

/* .custom-control-watermark {
  font-size: 200%;
  font-weight: bolder;
  color: #aaa;
  text-shadow: #555;
} */
</style>

<template>
<div class="statistic-block">
    <div class="container-fluid">
        <div class="row statistic-info">
            <div class="col-3">
                <p>Зарегистрировано пользователей: </p>
                <p class="info-number">{{count_users}}</p>
            </div>
            <div class="col-3">
                <p>Пользователей в сети: </p>
                <p class="info-number">{{count_online_users}}</p>
            </div>
            <div class="col-3">
                <p>Зарегистрировано кранов: </p>
                <p class="info-number">{{count_faucets}}</p>
            </div>
            <div class="col-3">
                <p>Кранов в сети: </p>
                <p class="info-number">{{count_online_faucets}}</p>
            </div>
        </div>
    </div>
    <div class="for-map-block">
        <l-map :zoom="zoom" :center="center" :options="mapOptions" :bounds="bounds" 
        :crs="crs_data"
        @update:center="centerUpdate" @update:zoom="zoomUpdate" @update:bounds="boundsUpdate">
            <l-tile-layer :url="url" :attribution="attribution" :options="layerOptions"/>
            <l-control>
                <div class="offine-faucets-checkbox-block">
                    <p>Краны offLine</p>
                    <div class="checkbox-block">
                        <input  id="seeOfflineFaucets"
                        v-model="offline_faucets_visible" 
                        @change="visibleOffLineFaucets"
                        type="checkbox" autocomplete="off">
                        <label for="seeOfflineFaucets">.</label>
                    </div>
                </div>

            </l-control>
            <l-marker v-for="marker in markers" :key="marker.id" :visible="marker.visible" 
            :lat-lng.sync="marker.position"
            :icon="getIcon(marker.connection)">
            <l-popup :content="marker.tooltip" />
            </l-marker>
        </l-map>
    </div>
</div>
</template>

<script>
import axios from 'axios'
import config from '@/config.js'
import loader from './elements/loader.vue'
import {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LControl,
    LIcon
} from 'vue2-leaflet';

export default {
    created() {
        get_info(this)
        this.setinterval_get_info = setInterval(() => {
            get_info(this)
            get_markers(this, this.curentBounds)
        }, config.UPDATE_PERIOD);
        get_markers(this, this.bounds)
        this.curentBounds = this.bounds
    },
    data() {
        return {
            count_users: 0,
            count_online_users: 0,
            count_faucets: 0,
            count_online_faucets: 0,
            setinterval_get_info: null,
            zoom: 12,
            crs_data: L.CRS.EPSG3395,
            center: L.latLng(60.539811, 102.2617187),
            // url: 'http://{s}.tile.osm.org/{z}/{x}/{y}.png',
            url: 'https://vec{s}.maps.yandex.net/tiles?l=map&v=19.02.11-0&x={x}&y={y}&z={z}&scale=2&lang=ru_RU',
            // attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
            attribution: '<a http="yandex.ru" target="_blank">Яндекс</a>',
            withPopup: L.latLng(47.413220, -1.219482),
            withTooltip: L.latLng(47.414220, -1.250482),
            currentCenter: L.latLng(60.539811, 102.2617187),
            showParagraph: false,
            bounds: L.latLngBounds([
                [41.96765920367816, 18.984375000000004],
                [73.80031816408652, 168.66210937500003]
            ]),
            curentBounds: null,
            mapOptions: {
                zoomSnap: 0.5,
                // crs: L.CRS.EPSG3395
            },
            layerOptions: {
                subdomains: ['01', '02', '03', '04'],
                reuseTiles: true,
                updateWhenIdle: false
            },
            markers: [],
            offline_faucets_visible: false,
            offline_icon: L.icon({
                iconUrl: 'static/img/marker-icon-offline.png',
                iconAnchor: [13, 41]
            }),
            online_icon: L.icon({
                iconUrl: 'static/img/marker-icon.png',
                iconAnchor: [13, 41]
            }),
        }
    },
    methods: {
        getStatistic: function () {
            get_info(this)
        },
        zoomUpdate(zoom) {
            this.currentZoom = zoom;
        },
        centerUpdate(center) {
            this.currentCenter = center;
        },
        showLongText() {
            this.showParagraph = !this.showParagraph;
        },
        innerClick() {
            alert('Click!');
        },
        boundsUpdate(bounds) {
            get_markers(this, bounds)
            this.curentBounds = bounds
        },
        visibleOffLineFaucets() {
            get_markers(this, this.bounds)
        },
        getIcon (connection) {
            return connection ? this.online_icon : this.offline_icon
        }
    },
    destroyed() {
        clearInterval(this.setinterval_get_info)
    },
    components: {
        LMap,
        LTileLayer,
        LMarker,
        LPopup,
        LControl,
        LIcon
    },
    computed: {
        getMarkers: function () {
            return this.markers
        }
    },
}

function get_info(vue_obj) {
    if (!!localStorage.token) {
        var post_data = new FormData()
        post_data.set('token', localStorage.token)
        axios({
                method: 'POST',
                url: config.API_HOST + '/admin-statistic/info',
                data: post_data
            })
            .then(function (response) {
                // vue_obj.users = response.data.users
                vue_obj.count_users = response.data.count_users
                vue_obj.count_online_users = response.data.count_online_users
                vue_obj.count_faucets = response.data.count_faucets
                vue_obj.count_online_faucets = response.data.count_online_faucets
            })
            .catch(function (error) {

            })
    }
}

function get_markers(vue_obj, bounds) {
    if (!!localStorage.token && bounds) {
        var post_data = new FormData()
        post_data.set('token', localStorage.token)
        post_data.set('northEast_lat', bounds._northEast.lat)
        post_data.set('northEast_lng', bounds._northEast.lng)
        post_data.set('southWest_lat', bounds._southWest.lat)
        post_data.set('southWest_lng', bounds._southWest.lng)
        post_data.set('faucets_offline', vue_obj.offline_faucets_visible)
        axios({
                method: 'POST',
                url: config.API_HOST + '/admin-statistic/get_map_points',
                data: post_data
            })
            .then(function (response) {
                // vue_obj.users = response.data.users
                vue_obj.markers = []
                response.data.faucets.forEach(faucet => {
                    var point_marker = {
                        id: faucet.id,
                        position: {
                            lat: faucet.coordinate[0],
                            lng: faucet.coordinate[1]
                        },
                        visible: true,
                        connection: faucet.connection,
                        tooltip: '<div><p>'+faucet.email+'</p><p>'+faucet.serial_number+'</p></div>',
                    }
                    console.log(point_marker)
                    vue_obj.markers.push(point_marker)
                });

            })
            .catch(function (error) {

            })
    }
}
</script>



// WEBPACK FOOTER //
// src/components/statistic.vue